import $ from 'jquery';
// import '../../../../../bower_components/slick-carousel/slick/slick';
import 'slick-carousel';

function lazySlider() {
    $('.lazy').slick({
        lazyLoad: 'ondemand',
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    autoplaySpeed: 4000
                }
            }
            // You can unslick at a given breakpoint now by adding:containActusAutomobiles
            // settings: "unslick"
            // instead of a settings object
        ]
    });

}
$(document).ready(function () {
    $('.slickSlider').slick({
        cssEase: 'ease-in-out',
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        draggable: true,
        adaptiveHeight: true
    });

    // lazySlider();


});

